import { useContext } from 'react';
import { LoginContext } from '~/App/contexts/Login';

export function useLogin() {
  return useContext(LoginContext);
}

export default useLogin;
